import styled from 'styled-components';

// INPUT ----------------------------------------------------------------
export const Switch = styled.div`
  display: flex;
  align-items: center;

  label {
    display: block;
  }
  
  input {
    display: block!important;
    appearance: none;
    position: relative;
    background-color: ${({theme}) => theme.colors.grayscale[200]};
    border-radius: 22px;
    width: 44px;
    height: 24px;
    cursor: pointer;
    margin-left: 10px;
    transition: all .1s ease-in-out;

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 2px;
      left: 2px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #FFFFFF;
      transition: all .2s ease-in-out;
    }
    
    &:checked::before {
      left: 22px;
    }
    
    &:checked {
      background-color: ${({theme}) => theme.colors.primary[400]};
    }
    
    &:disabled {
      background-color: ${({theme}) => theme.colors.grayscale[100]};
      cursor: default;
    }
  }
  
`;
export const TextSwitch = styled.div<{ $text: string }>`
  display: flex;
  align-items: center;

  label {
    display: block;
  }
  
  input {
    display: block!important;
    appearance: none;
    position: relative;
    background-color: ${({theme}) => theme.colors.grayscale[200]};
    border-radius: 22px;
    width: 58px;
    height: 30px;
    cursor: pointer;
    margin-right: 10px;
    transition: all .1s ease-in-out;

    &:before {
      content: '${(props) => props.$text}';
      display: block;
      position: absolute;
      top: 2px;
      left: 2px;
      width: 34px;
      height: 26px;
      border-radius: 13px;
      background-color: #FFFFFF;
      transition: all .2s ease-in-out;
      font-size: 11px;
      text-align: center;
      line-height: 26px;
      font-weight: 600;
    }
    
    &:checked::before {
      left: 22px;
    }
    
    &:checked {
      background-color: ${({theme}) => theme.colors.primary[400]};
    }
    
    &:disabled {
      background-color: ${({theme}) => theme.colors.grayscale[100]};
      cursor: default;
    }
  }
`;

// BUTTON ---------------------------------------------------------------
export const PrimaryButton = styled.button`
  padding: 0 20px;
  font-weight: 600; 
  border-radius: 8px;
  color: ${({theme}) => theme.colors.grayscale[50]};
  background-color: ${({theme}) => theme.colors.primary[400]};

  &:hover, &:active {
    background-color: ${({theme}) => theme.colors.primary[500]};
  }
  &:disabled {
    color: ${({theme}) => theme.colors.grayscale[100]};
    background-color: ${({theme}) => theme.colors.grayscale[200]};
  }
`;

export const TertiaryButton = styled.button`
  padding: 0 20px;
  color: ${({theme}) => theme.colors.grayscale[400]};
  border: 1px solid ${({theme}) => theme.colors.grayscale[300]};
  border-radius: 8px;
  background-color: #FFFFFF;

  &:hover, &:active {
    border: 1px solid ${({theme}) => theme.colors.grayscale[400]};
  }
  &:disabled {
    color: ${({theme}) => theme.colors.grayscale[200]};
    background-color: ${({theme}) => theme.colors.grayscale[50]};
    border: 1px solid ${({theme}) => theme.colors.grayscale[200]};
  }
`;

export const IconButton = styled.button`
  color: ${({theme}) => theme.colors.grayscale[500]};
  padding: 0 20px;
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.colors.grayscale[300]};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  white-space: nowrap;

  > svg {
    stroke: ${({theme}) => theme.colors.grayscale[500]};
    margin-right: 4px;
  }

  &:hover, &:active {
    color: ${({theme}) => theme.colors.primary[400]};
    border: 1px solid ${({theme}) => theme.colors.primary[400]};
    > svg {
      stroke: ${({theme}) => theme.colors.primary[400]};
    }
  }

  &:disabled {
    color: ${({theme}) => theme.colors.grayscale[200]};
    border: 1px solid ${({theme}) => theme.colors.grayscale[200]};
    > svg {
      stroke: ${({theme}) => theme.colors.grayscale[200]};
    }
  }

  &.active {
    background-color: ${({theme}) => theme.colors.primary[400]};
    border: 1px solid ${({theme}) => theme.colors.primary[400]};
    color: #FFFFFF;

    > svg {
      stroke: #FFFFFF;
    }
  }
`;

export const MoreButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background-image: url(/assets/base/more.svg);
  background-size: 24px 24px;
  background-position: center center;
  background-repeat: no-repeat;
  margin-top: 6px;

  &:hover, &:active {
    background-color: ${({theme}) => theme.colors.grayscale[100]};
  }

  &:disabled {
    background-color: transparent;
    opacity: .4;
  }
`;

export const Icons = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 0 auto;
  background-color: #F7F8FA;
  background-position: center center;
  background-repeat: no-repeat;
`;

export const PasswordIcon = styled(Icons)`
  background-image: url(/assets/icons/password.svg);
  background-size: 48px 48px;
`;

export const EmailIcon = styled(Icons)`
  background-image: url(/assets/icons/email.svg);
  background-size: 48px 48px;
`;

export const RestrictIcon = styled(Icons)`
  background-image: url(/assets/icons/restrict.svg);
  background-size: 44px 48px;
`;

export const ErrorIcon = styled(Icons)`
  background-image: url(/assets/icons/error.svg);
  background-size: 55px 48px;
`;

export const NotifyTitle = styled.div`
  text-align: center;
  margin: 40px 0;
  white-space: pre-wrap;

  p {
    color: #4D5E80;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  span {
    color: #7D8FB3;
    line-height: 20px;
  }
`;